import React, { useState } from 'react';
import './Creations.css';
import img11 from '../../assets/images/creations/home_decor/sunflower.jpg';
import img21 from '../../assets/images/creations/apparel/socks_2.png';
import img31 from '../../assets/images/creations/bags/bag_1.png';
import img51 from '../../assets/images/creations/accessory/hairband_1.png';
interface Creation {
  id: number;
  title: string;
  description: string;
  category: string;
  image: string;
}

const creations: Creation[] = [
  {
    id: 1,
    title: 'Sunblossom Pot',
    description: "A charming floral accent designed to brighten your space with warmth and handcrafted elegance. Perfect for adding a soft, cheerful touch to any corner.",
    category: 'Home Decor',
    image: img11,
  },
  {
    id: 2,
    title: 'SoftStride Socks',
    description: 'Cozy, breathable, and made for everyday comfort—these socks wrap your feet in softness with a timeless handmade feel.',
    category: 'Accessories',
    image: img21,
  },
  {
    id: 3,
    title: 'PetalFold Bag',
    description: 'Inspired by delicate folds and a warm pink hue, this bag brings a playful yet graceful vibe to any outfit.',
    category: 'Accessories',
    image: img31,
  },
  {
    id: 4,
    title: 'SunGlow Hairband',
    description: 'A soft and stylish hairband designed to keep your look effortlessly neat while adding a warm pop of color.',
    category: 'Accessories',
    image: img51,
  }
  // {
  //   id: 5,
  //   title: 'CozyNest Cushion',
  //   description: 'Add warmth and texture to your home with this soft, inviting cushion designed for cozy living spaces.',
  //   category: 'Home Decor',
  //   image: img51,
  // },

];

const categories = ['All Product', 'Home Decor', 'Accessories', 'Apparel'];

function Creations(): React.ReactElement {
  const [activeCategory, setActiveCategory] = useState<string>('All Product');

  const filteredCreations =
    activeCategory === 'All Product'
      ? creations
      : creations.filter((c) => c.category === activeCategory);

  return (
    <section className="creations" id="creations">
      <div className="creations-decor creations-decor-tl" />
      <div className="creations-decor creations-decor-br" />
      <div className="creations-inner">
        <span className="creations-label">Products</span>
        <h2>Our Products</h2>
        <p className="creations-intro">
          Have a good setup for your minimalist home
        </p>
        <nav className="creations-filter">
          {categories.map((cat) => (
            <button
              key={cat}
              className={`filter-btn ${activeCategory === cat ? 'active' : ''}`}
              onClick={() => setActiveCategory(cat)}
            >
              {cat}
            </button>
          ))}
        </nav>
        <div className="creations-grid">
          {filteredCreations.map((item) => (
            <article key={item.id} className="creation-card">
              <div className="creation-image">
                <img src={item.image} alt={item.title} className="creation-img" />
              </div>
              <div className="creation-info">
                <h3>{item.title}</h3>
                <p className="creation-description">{item.description}</p>
                <span className="creation-separator" />
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Creations;
